import { render } from "./markettrends-tabs.vue?vue&type=template&id=3d82f8f4"
import script from "./markettrends-tabs.js?vue&type=script&lang=js"
export * from "./markettrends-tabs.js?vue&type=script&lang=js"

import "./markettrends-tabs.vue?vue&type=style&index=0&id=3d82f8f4&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__